// extracted by mini-css-extract-plugin
export default {"buy":"Buy_buy__yRZ-o","container":"Buy_container__hhRVK"};